import { useState, useEffect } from "react";
import { Banner } from "@shopify/polaris";
import { showNewMessage } from '@intercom/messenger-js-sdk';
import Langauge from "../../i18n/Language";
const t = Langauge;

const BannerMsgMoudle = (props) => {
    const {
        MessageInfo,
        callbackCloseBanner,
    } = props;

    const [pageTipBanner, setPageTipBanner] = useState({});

    useEffect(() => {
        window.scrollTo(0, 0);
        setPageTipBanner(MessageInfo);
    }, [MessageInfo]);

    //点击联系客服
    const handleContactService = () => {
        try {
            showNewMessage();
        } catch (e) {
            props.toggleToast(t("Try again later"), true);
        }
    }

    // 错误警告banner
    const BannerMsg = Boolean(pageTipBanner?.msg) && <Banner
        tone={pageTipBanner.tone}
        title={pageTipBanner.msg}
        onDismiss={() => {
            setPageTipBanner({});
            callbackCloseBanner();
        }}
        action={{
            content: t("Contact us"),
            onAction: handleContactService
        }}
    ></Banner>

    return BannerMsg;
}

export default BannerMsgMoudle;